module.exports = __webpack_public_path__ + "static/media/om.b9b7d0bc.svg";